import { render, staticRenderFns } from "./GiftOrder.vue?vue&type=template&id=27e63dc0&scoped=true&"
import script from "./GiftOrder.vue?vue&type=script&lang=js&"
export * from "./GiftOrder.vue?vue&type=script&lang=js&"
import style0 from "./GiftOrder.vue?vue&type=style&index=0&id=27e63dc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e63dc0",
  null
  
)

export default component.exports